import { DictType, StatisticPeriod } from "@pma/types"

export const changeTypes = [
  {
    id: 1,
    en: "new project",
    he: "",
    meta: {
      action: "Created",
      entity: "Project",
    },
  },
  {
    id: 2,
    en: "new task",
    he: "",
    meta: {
      action: "Created",
      entity: "Task",
    },
  },
  {
    id: 3,
    en: "edit project",
    he: "",
    meta: {
      action: "Edited",
      entity: "Project",
    },
  },
  {
    id: 4,
    en: "edit task",
    he: "",
    meta: {
      action: "Edited",
      entity: "Task",
    },
  },
  {
    id: 5,
    en: '"depend on" task status change',
    he: "",
    meta: {
      action: "Edited",
      entity: "Task",
    },
  },
  {
    id: 6,
    en: "move task to project",
    he: "",
    meta: {
      action: "Moved",
      entity: "Project",
    },
  },
  {
    id: 7,
    en: "file change",
    he: "",
    label: "Created",
    meta: {
      action: "Changed",
      entity: "File",
    },
  },
]

export const periodOptions: StatisticPeriod[] = [
  {
    label: "Last 1 Month",
    label_he: "1 חודש שעבר",
    period_type: 4,
    number_of_periods: 1,
  },
  {
    label: "Last 3 Months",
    label_he: "3 חודשים אחרונים",
    period_type: 4,
    number_of_periods: 3,
  },
  {
    label: "Last 6 Months",
    label_he: "6 חודשים אחרונים",
    period_type: 4,
    number_of_periods: 6,
  },
]

export const permissionsDescriptions: DictType = {
  project_view_only_members: "Allows only project members to view the project",
  owner_can_delete_project: "Grants the project owner permission to delete the project",
  project_edit_only_owner: "Restricts project editing to the project owner only",
  organization_accout_have_full_access: "Grants full access to the organization account",
  user_properties_edit_only_organization_account:
    "Allows only the organization account to edit user properties",
  dictionary_edit_only_organization_account:
    "Restricts dictionary editing to the organization account only",
  add_new_project_only_organization_account:
    "Allows only the organization account to create new projects",
  share_projects: "Enables sharing projects with other users",
  diary_location_mandatory: "Makes location mandatory for diary entries",
  teams_edit_only_organization_account: "Restricts team management to the organization account",
  folders_managment_only_project_owner: "Allows only the project owner to manage folders",
  file_delete_by_project_members: "Permits project members to delete files",
  inform_by_email: "Enables email notifications",
  inform_by_whatsapp: "Enables WhatsApp notifications",
}
